import React from 'react'
import styled from 'styled-components'

import Button from '~/components/common/button'
import { translate } from '~/core/translate'
import Modal from '~/components/common/modal'
import { hideDialog } from '~/actions/ui'

const CopyInfoDescription = styled.div`
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
`

const StyledButton = styled(Button)`
  min-width: 120px;
`

const CopyInfoScreen = ({ copyInfo }) => (
  <Modal
    footerChildren={(
      <>
        <StyledButton onClick={copyInfo}>
          {translate('copy_info')}
        </StyledButton>
        <StyledButton secondary onClick={hideDialog}>
          {translate('close')}
        </StyledButton>
      </>
    )}
    title={translate('password_info_updated')}
  >

    <CopyInfoDescription>{translate('update_upcoming_meetings')}</CopyInfoDescription>
  </Modal>
)

export default CopyInfoScreen
